<template>
    <div id="Layout">
        <a-spin :spinning="isLoading">
            <div class="app-content" v-if="!isLoading">
                <HeadrContainer>
                </HeadrContainer>
                <Breadcrumb v-if="!isHomePagge" :routerConfig="routerConfig"></Breadcrumb>
                <transition name="fade">
                    <router-view/>
                </transition>
            </div>

        </a-spin>
    </div>
</template>

<script>
    import HeadrContainer from '@/components/HeadrContainer.vue'
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import {getUserInfo} from "../../views/Home/homeApiMethod";

    export default {
        name: "Layout",
        components: {
            HeadrContainer,
            Breadcrumb
        },
        data() {
            return {
                isHomePagge: true,
                activeKey: '',
                isLoading: false,
                routerConfig: [{
                    name: 'Home',
                    path: '/'
                }]
            }
        },
        destroyed() {
        },
        created() {
            const defR = this.$store.getters.getDefRouters;
            if (defR.length > 0) {
                this.routerConfig = defR
            }
            if (this.routerConfig.length > 1) {
                this.isHomePagge = false;
            }
            this.getUserInfo()
        },
        watch: {
            $route: function (newVal) {
                // console.log(newVal)
                this.activeKey = newVal.path
                if (newVal) {
                    this.routerConfig = []
                    this.routerConfig.push({
                        name: 'Home',
                        path: '/',
                        fullPath: '/'
                    });
                    this.activeKey = newVal.path
                    if (this.activeKey !== '/' ) {
                        if (this.activeKey.indexOf('home') !== -1) {
                            this.isHomePagge = true
                        } else {
                            this.isHomePagge = false
                            if (newVal.fullPath.indexOf('task-list') !== -1) {
                                this.routerConfig.push({
                                    name: 'Task List',
                                    path: '/task-list',
                                    fullPath: '/task-list?pageType=2'
                                })
                                if (newVal.fullPath.indexOf('task-list/task-detail') !== -1) {
                                    this.routerConfig.push({
                                        name: 'Task Detail',
                                        path: this.activeKey,
                                        fullPath: newVal.fullPath
                                    })
                                }
                            } else if (newVal.fullPath.indexOf('request-list') !== -1) {
                                this.routerConfig.push({
                                    name: 'Request List',
                                    path: '/request-list',
                                    fullPath: '/request-list?pageType=1'
                                })
                                if (newVal.fullPath.indexOf('request-list/case-detail') !== -1) {
                                    this.routerConfig.push({
                                        name: 'Request Detail',
                                        path: this.activeKey,
                                        fullPath: newVal.fullPath
                                    })
                                } else if (newVal.fullPath.indexOf('request-list/raise-new-case') !== -1) {
                                    const lastObj = this.routerConfig[this.routerConfig.length - 1]
                                    if (lastObj.fullPath.indexOf('request-list/case-detail') !== -1) {
                                        this.routerConfig.splice(this.routerConfig.length-1 ,1)
                                    } else if (lastObj.fullPath === newVal.fullPath) {
                                        return;
                                    }
                                    this.routerConfig.push({
                                        name: 'Raise New Detail',
                                        path: this.activeKey,
                                        fullPath: newVal.fullPath
                                    })
                                }
                            } else {
                                this.routerConfig.push({
                                    name: newVal.name,
                                    path: this.activeKey,
                                    fullPath: newVal.fullPath
                                })
                            }
                        }
                    }
                    this.$store.commit('setDefRouters', this.routerConfig);

                    if (this.routerConfig.length > 1) {
                        this.isHomePagge = false;
                    }
                } else {
                    this.$store.commit('setDefRouters', []);
                }
            }
        },

        methods: {
            getUserInfo() {
                this.isLoading = true;
                getUserInfo().then(res => {
                    this.$store.dispatch('setUserInfo', res)
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .app-content {
        padding-left: 8em;
        padding-right: 8em;
        min-width: 700px;
        width: 100%;
        height: auto;
    }
</style>
